import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import type { UseQueryResult } from 'react-query';
import type { HotlineMetaData } from '../../modules/algebra/global';

const HotlineInfo: FC<{ statusQuery?: UseQueryResult<HotlineMetaData> }> = ({ statusQuery }) => {
  return (
    <div className="hotline-connect">
      <div className="w-full pt-12">
        <div className="grid grid-row-5 lg:grid-cols-5 md:grid-cols-1  flex w-full 2xl:w-10/12 lg:m-auto">
          <div className="relative h-100">
            <Paper className="px-4 md:px-10 h-full relative" elevation={0}>
              <Typography variant="h2" className="hotline-connect-header relative">
                What is the Online Hotline?
              </Typography>
              <Typography variant="body1" className="py-6 relative">
                Whether you’re looking for support, information, advice, or a referral, our trained support specialists are ready to help.
              </Typography>
              <Link href="https://rainn.org/about-national-sexual-assault-online-hotline" className="learn-more">
                Learn More
              </Link>
            </Paper>
          </div>
          <div className="relative h-100">
            <Paper className="px-4 md:px-10 h-full relative" elevation={0}>
              <Typography variant="h2" className="hotline-connect-header  relative">
                Help Over the Phone
              </Typography>
              <Typography variant="body1" className="py-6  relative">
                Call the {statusQuery?.data?.endpointTitle || process.env.NX_ORGANIZATION_NAME} Hotline to talk to a trained staff member from your local sexual assault service provider.
              </Typography>
              <Link href="tel:800.656.HOPE (4673)" className="m-auto w-3/4 bg-pc-1 absolute bottom-0 right-0 left-0 text-tc-1 font-bold text-xl block text-center py-5 rounded ">
                800.656.HOPE (4673)
              </Link>
            </Paper>
          </div>
          <div className="relative h-100">
            <Paper className="px-4 md:px-10 h-full relative" elevation={0}>
              <Typography variant="h2" className="hotline-connect-header relative">
                Help Via Mobile App
              </Typography>
              <Typography variant="body1" className="py-6 relative">
                Get support, information, advice, or a referral anywhere, anytime from your smartphone with the RAINN mobile app.
              </Typography>
              <Link href="https://www.rainn.org/new-rainn-mobile-app-offers-survivors-loved-ones-another-option-support" className="learn-more">
                Learn More
              </Link>
            </Paper>
          </div>
          <div className="relative h-100">
            <Paper className="px-4 md:px-14 h-full relative" elevation={0}>
              <Typography variant="h2" className="hotline-connect-header relative">
                Help Via Chatbot
              </Typography>
              <Typography variant="body1" className="py-6 relative">
                Ask Iris, the new RAINN chatbot, for resources, referrals and information.
              </Typography>
              <Link href="https://www.rainn.org/iris" className="learn-more">
                Learn More
              </Link>
            </Paper>
          </div>
          <div className="relative h-100">
            <Paper className="px-4 md:px-14 h-full relative" elevation={0}>
              <Typography variant="h2" className="hotline-connect-header relative">
                Help Via WhatsApp
              </Typography>
              <Typography variant="body1" className="py-6 relative">
                Message us on whatsapp for resources, referrals and information.
              </Typography>
              <Link
                href={`https://wa.me/${process.env.NX_WHATSAPP_NUMBER}`}
                className="m-auto w-3/4 bg-pc-1 absolute bottom-0 right-0 left-0 text-tc-1 font-bold text-xl block text-center py-5 rounded"
              >
                Chat Now
              </Link>
            </Paper>
          </div>
        </div>
      </div>
      <div className="md:px-12 sm:px-0">
        <Paper className="hotline-connect-safety-message" elevation={0}>
          <Link href="https://rainn.org/articles/safety-planning" className="text-tc-2">
            <span className="font-bold">Your safety is important.</span> If you are in immediate danger, call 911.
          </Link>
        </Paper>
      </div>
    </div>
  );
};

export default HotlineInfo;
